<div class="flex flex-col w-full min-w-0 sm:absolute sm:inset-0 sm:overflow-hidden">
  <mat-drawer-container class="flex-auto sm:h-full">
    <mat-drawer class="dark:bg-gray-900" [ngClass]="{ 'w-full lg:w-2/4': drawerOpened }" [autoFocus]="false" [position]="drawerPosition" [mode]="drawerMode" [opened]="drawerOpened" #drawer>
      <!-- Main -->
      <div>
        <div>
          <mat-card class="modal">
            <mat-card-header>
              <mat-card-title class="text-lg font-medium" *ngIf="!addUserData.id">Add User</mat-card-title>
              <mat-card-title class="text-lg font-medium" *ngIf="addUserData.id">Update User</mat-card-title>
              <div class="spacer">&nbsp;</div>
              <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close" (click)="drawerOpened = false;">
                <mat-icon>close</mat-icon>
              </button>
            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content class="my-4" fuseScrollbar>
              <form class="" #userisNgForm="ngForm">
                <div class="grid grid-cols-2 gap-4">
                  <mat-form-field class="w-full mb-4" *ngIf="!addUserData.id">
                    <mat-label>First Name</mat-label>
                    <input matInput placeholder="Add First Name" type="text" required name="firstName" [(ngModel)]="addUserData.first_name" />
                  </mat-form-field>
                  <mat-form-field class="w-full mb-4" *ngIf="!addUserData.id">
                    <mat-label>Last Name</mat-label>
                    <input matInput placeholder="Add Last Name" type="text" required name="lastName" [(ngModel)]="addUserData.last_name" />
                  </mat-form-field>
                  <mat-form-field class="w-full mb-4" *ngIf="!addUserData.id">
                    <mat-label>Email</mat-label>
                    <input matInput placeholder="Add Email" type="email" required name="email" [(ngModel)]="addUserData.email" />
                  </mat-form-field>
                  <mat-form-field class="w-full mb-4">
                    <mat-label>Choose Role</mat-label>
                    <mat-select class="" placeholder="Choose role" name="role" required [(ngModel)]="addUserData.roles">
                      <mat-option *ngFor="let role of rolesData" [value]="role.name">{{ role.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="my-2">
                  <fuse-alert [appearance]="'border'" [type]="'info'">
                    <div class="flex flex-col gap-2">
                      <div>Distributors level access</div>
                    </div>
                  </fuse-alert>
                </div>
                <div class="grid grid-cols-1 gap-4">
                  <mat-radio-group [(ngModel)]="addUserData.distributorType" name="distributor" class="flex">
                    <mat-radio-button [value]="'all'" [color]="'primary'" name="distributorType" class="flex items-center mr-4">
                      All Distributors
                    </mat-radio-button>
                    <mat-radio-button [value]="'specific'" [color]="'primary'" name="specificdistributorType" class="flex items-center">
                      Specific Distributors
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div *ngIf="addUserData.distributorType === 'specific'">
                  <div class="grid grid-cols-1 gap-4">
                    <mat-card-title class="text-xl font-medium ml-2 mt-2">
                      Choose distributors as
                    </mat-card-title>
                    <mat-radio-group [(ngModel)]="addUserData.distributorTypeData" name="distributortype" class="flex" (change)="clearDistributors()">
                      <mat-radio-button [value]="'allowed'" [color]="'primary'" name="alloweddistributorType" class="flex items-center mr-4">
                        Allowed Distributors
                      </mat-radio-button>
                      <mat-radio-button [value]="'excluded'" [color]="'primary'" name="excludedistributorType" class="flex items-center">
                        Exclude Distributors
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <mat-form-field class="mb-4 w-full" *ngIf="addUserData.distributorTypeData">
                    <mat-select #companySelect id="sSearchCompanyInput" class="w-full" placeholder="Choose Distributors" name="distributorvalue" [multiple]="true" [(ngModel)]="addUserData.distributor">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="companyFilterCtrl" [placeholderLabel]="searchTxt" [noEntriesFoundLabel]="'No matching Distributor found'" [searching]="searching" [enableClearOnEscapePressed]="true">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option [matTooltip]="company.distributor_name" [matTooltipPosition]="'left'" *ngFor="let company of distributorsData | search: companyFilterCtrl.value" [id]="company.distributor_name" [value]="company.id">
                        <span> {{ company.distributor_name }}</span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                
                <div class="flex items-center justify-end mt-4 p-2 border-t bg-gray-50 dark:bg-transparent ml-auto">
                  <button class="ml-auto" mat-button [matTooltip]="'Cancel'" (click)="drawerOpened = false;">
                    Cancel
                  </button>
                  <button class="ml-2" mat-flat-button [color]="'primary'" type="button" appPreventMultiClick
                    [matTooltip]="'Save'" (click)="AddUser(addUserData)" [disabled]="!userisNgForm.form.valid"
                    *ngIf="!addUserData.id">
                    Save
                  </button>
                  <button class="ml-2" mat-flat-button [color]="'primary'" type="button" appPreventMultiClick
                    [matTooltip]="'Save'" (click)="UpdateUser(addUserData)" [disabled]="!userisNgForm.form.valid"
                    *ngIf="addUserData.id">
                    Update
                  </button>
                </div>
              </form>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </mat-drawer>
    <!-- Drawer content -->
    <!--<mat-drawer-content class="flex flex-col " fuseScrollbar>
            <div class="w-auto rounded-2xl" fuseScrollbar>
                <stable aria-label="Assets Table" role="table" [sTableOptions]="deviTableOptions"
                        (hyperlinkCallback)="linkClick($event)"></stable>
            </div>
        </mat-drawer-content>-->

    <!-- Data Drawer Content Table View -->
    <mat-drawer-content class="h-full">
      <div>
        <stable aria-label="Assets Table" role="table" [sTableOptions]="deviTableOptions" (actionCallback)="actionCall($event)"(addCallback)="newUser()"
          (hyperlinkCallback)="linkClick($event)"></stable>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
  
</div>

<!-- Display API Key Data -->
<s-modal id="displayApiKeyData" *ngIf="apiKeyData">
  <mat-card class="modal w-[40vw]">
    <mat-card-header>
      <mat-card-title class="text-lg font-medium">API Key </mat-card-title>
      <div class="spacer">&nbsp;</div>
      <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
        (click)="_modalService.close('displayApiKeyData')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content class="my-4" fuseScrollbar>
      <mat-list>
        <mat-list-item class="border border-gray-300 rounded p-4 mb-2">
          <div class="flex">
            <p class="font-bold mr-2">Client ID:</p>
            <p>{{ apiKeyData.client_id }}</p>
            <div class="spacer"></div>
            <button (click)="copyOption(apiKeyData.client_id)" matTooltip="Copy" class="text-blue-500">
              <mat-icon class="text-blue-500 w-6 h-6" svgIcon="mat_solid:file_copy"></mat-icon>
            </button>
          </div>
        </mat-list-item>
        <mat-list-item class="border border-gray-300 rounded p-4 mb-2">
          <div class="relative overflow-auto flex">
            <p class="font-bold mr-2 fixed bg-white">Client Secret:</p>
            <p class="flex flex-wrap">{{ apiKeyData.client_secret }}</p>
            <div class="spacer"></div>
            <div class="flex-shrink-0 sticky right-0 bg-white">
              <button (click)="copyOption(apiKeyData.client_secret)" matTooltip="Copy" class="text-blue-500">
                <mat-icon class="text-blue-500 w-6 h-6" svgIcon="mat_solid:file_copy"></mat-icon>
              </button>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
      <div class="flex items-center justify-start mt-4 p-2 border-t bg-gray-50 dark:bg-transparent ml-auto">
        <button class="ml-2 bg-red-700 text-white" mat-button [matTooltip]="'Close'"
          (click)="_modalService.close('displayApiKeyData')">Close</button>
      </div>
    </mat-card-content>
  </mat-card>
</s-modal>